export class ClInvoiceValidation {
  constructor(dom, payment, formattedPaymentAmount) {
    this.dom = dom;
    this.payment = payment;
    this.formattedPaymentAmount = formattedPaymentAmount;
  }

  validate() {
    console.log("=> Chile Invoice : ", this.dom.documentElement.nodeName);

    switch (this.receiptType()) {
      case "receipt": {
        return this.validateBoleta();
      }
      case "invoice":
        return this.validateInvoice();
      default:
        return {error: true, message: "Archivo XML inválido"};

    }
  }

  receiptType() {
    switch (this.dom.documentElement.nodeName) {
      case "datos":
        return "receipt";
      case "EnvioDTE":
        return "invoice";
      case "SetDTE":
        return "invoice";
      case "DTE":
        return "invoice";
    }
  }


  get fiscalID() {
    let tag = this.dom.documentElement.querySelector("RUTEmisor");
    if (tag) {
      return tag.textContent;
    }

    tag = this.dom.documentElement.querySelector("rutEmisor");
    if (tag) {
      return tag.textContent;
    }
  }

  get fitpassFiscalID() {
    let tag = this.dom.documentElement.querySelector("RUTRecep");
    if (tag) {
      return tag.textContent;
    }

    tag = this.dom.documentElement.querySelector("rutReceptor");
    if (tag) {
      return tag.textContent;
    }
  }

  validateBoleta() {
    console.log("Checking fiscal ID", this.fiscalID);

    // if (!this.fiscalID.includes('-')) {
    //   return { error: true, message: `Archivo XML inválido, RUT ${this.fiscalID} no es válido,
    //     debe contener el digito verificador, ejemplo: 30686957-4.
    //   ` };
    // }

    const tag = this.dom.documentElement.querySelector("totalHonorarios");
    if (tag == null) {
      return {error: true, message: "Archivo XML inválido, monto de factura no encontrado"};
    }

    console.log("Checking fiscal ID", this.fitpassFiscalID);
    if (this.fitpassFiscalID !== "77044851") {
      return {
        error: true,
        message: `La factura no coincide con nuestros datos fiscales: Fitpass SpA, RUT 77.044.851-4
                Favor de revisarlos. Gracias`
      };
    }

    const liquidoTag = this.dom.documentElement.querySelector("liquidoHonorarios");

    if (liquidoTag == null) {
      return {error: true, message: "Archivo XML inválido, monto \"liquido horarios\" no encontrado"};
    }

    return this.validaAmount(
      parseInt(tag.textContent, 10),
      parseInt(liquidoTag.textContent, 10),
    );
  }


  validateInvoice() {
    console.log("Checking fitpass fiscal ID", this.fitpassFiscalID);

    if (this.fitpassFiscalID !== "77044851-4") {
      return {
        error: true,
        message: `La factura no coincide con nuestros datos fiscales: Fitpass SpA, RUT 77.044.851-4
         Favor de revisarlos. Gracias`
      };
    }

    const tag = this.dom.documentElement.querySelector("MntTotal");
    if (tag == null) {
      return {error: true, message: "Archivo XML inválido, monto de factura no encontrado"};
    }

    return this.validaAmount(parseInt(tag.textContent, 10));
  }

  validaAmount(amount, liquidoHonorarios) {
    const payment = this.payment;
    const min = Math.trunc(payment) - 5;
    const max = Math.trunc(payment) + 5;
    const truncAmount = Math.trunc(amount);

    const formattedAmount = new Intl.NumberFormat(
      "es-CL",
      {
        style: "currency",
        currency: "CLP",
      }
    ).format(amount);


    console.log("=> Amounts min: ", min, " value: ", truncAmount, " max: ", max);

    if (liquidoHonorarios != null && liquidoHonorarios >= truncAmount) {
      return {
        error: true, message: `
        Boleta incorrecta, recuerda que la boleta debe incluir el 12.25% Impto. Retenido sobre el total del reporte enviado.
        Para dudas adicionales, favor de enviar correo a contacto@fitpass.cl
      `.trim()
      };
    }

    if (truncAmount < min || truncAmount > max) {
      if (this.receiptType() === "receipt") {
        return {
          error: true, message: `
          Monto de la boleta no coincide, ${formattedAmount},
          recuerda que la boleta debe incluir el 11.5% Impto.
          Retenido sobre el total del reporte enviado.
          Para dudas adicionales, favor de enviar correo a contacto@fitpass.cl"
        `.trim()
        };
      } else {
        return {
          error: true, message: `
          Monto de la factura no coincide, ${formattedAmount}, favor de revisar
          el reporte de visitas fitpass, les recordamos que las facturas son exentas de IVA,
          favor de enviar correo a contacto@fitpass.cl
        `.trim()
        };
      }
    }

    return {error: false, message: ""};
  }

}
